export default function getDisplayFormattedDateTimeFromJsDate(date, options) {
    const usedOptions = Object.assign({ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }, options);
    try {
        return new Intl.DateTimeFormat([], usedOptions).format(date);
    }
    catch (_a) {
        console.warn('non-date value', date);
        return ''; // should we terun a '<invalid date>' string?
    }
}
